import {
  Box,
  Button,
  CircularProgress,
  Snackbar,
  SnackbarCloseReason,
  TextField,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useState } from "react";
import { useLogin } from "react-admin";

interface LoginComponentProps {
  setIsForgotPassword: (value: boolean) => void;
}

const LoginComponent = ({ setIsForgotPassword }: LoginComponentProps) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [isErrorLogin, setIsErrorLogin] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const login = useLogin();

  // action button for login
  const submitLogin = async (e: any) => {
    e.preventDefault();
    const credentials = {
      email,
      password,
    };
    setIsLoading(true);

    // try {
    //   const user = await Auth.signIn(email, password);
    //   setIsLoading(false);
    //   console.log("USER", user);
    // } catch (error) {
    //   setIsLoading(false);
    // }

    login(credentials).catch((err: any) => {
      setIsLoading(false);
      setIsErrorLogin(true);

      // Extract error message from API response
      const message = err?.message || "Invalid email or password";
      setErrorMessage(message);
    });
  };
  // action link for forgot password

  const onClickForgot = () => {
    setIsForgotPassword(true);
  };

  const handleKeyDown = async (event: any) => {
    if (event.key === "Enter") {
      await submitLogin(event);
    }
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setIsErrorLogin(false);
  };
  return (
    <>
      <div
        style={{
          fontSize: "24px",
          fontWeight: 500,
        }}
      >
        Sign in to your account
      </div>

      <div style={{ width: "60%", marginTop: "20px" }}>
        <form name="loginform" onSubmit={submitLogin} onKeyDown={handleKeyDown}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "2.25rem",
            }}
          >
            <TextField
              data-testid="email"
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              label="Email"
              variant="filled"
              size="small"
            />
            <TextField
              data-testid="password"
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              label="Password"
              type="password"
              variant="filled"
              size="small"
            />
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                gap: "1.25rem",
              }}
            >
              <Button
                onClick={submitLogin}
                style={{
                  backgroundColor: "#2b6cb0",
                  color: "#FFFFFF",
                  marginLeft: "0px",
                }}
                variant="contained"
                disabled={isLoading}
                fullWidth
              >
                {isLoading ? (
                  <CircularProgress size={25} color="inherit" />
                ) : (
                  "Sign In"
                )}
              </Button>
              <Button
                variant="text"
                style={{
                  color: "#555555",
                  width: "fit-content",
                  padding: "5px",
                  margin: "auto",
                }}
                onClick={onClickForgot}
              >
                Forgot Password?
              </Button>
            </Box>

            <Snackbar
              open={isErrorLogin}
              autoHideDuration={5000}
              onClose={handleClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <Alert severity="error" variant="filled" onClose={handleClose}>
                {errorMessage}
              </Alert>
            </Snackbar>
          </div>
        </form>
      </div>
    </>
  );
};

export default LoginComponent;
